import React, { Component } from "react";
import ReactDOM from "react-dom";
import moment from 'moment';
import { withRouter, NavLink } from "react-router-dom";
import { connect } from "react-redux";
import { showContract } from "../../actions/contracts";
import { fetchTerms } from "../../actions/contractTerms";
import { fetchConfig, setDefaultConfig } from "../../actions/configuration";
import { fetchAnimalTypes } from "../../actions/addAnimalType";
import { PDFExport, savePDF } from "@progress/kendo-react-pdf";
import HeaderTemplate from "./header.js";
import { stateToHTML } from "draft-js-export-html";
import { EditorState, convertFromRaw } from "draft-js";
import { BASE_URL } from "../../utils/helper";
import "./style.css";
import config from "../../config";
import { ContactMail } from "@material-ui/icons";

async function toDataURL(src, callback) {
  var img = new Image();
  img.crossOrigin = "Anonymous";
  img.onload = await function() {
    var canvas = document.createElement("CANVAS");
    var ctx = canvas.getContext("2d");
    var dataURL;
    canvas.height = this.naturalHeight;
    canvas.width = this.naturalWidth;
    ctx.drawImage(this, 0, 0);
    dataURL = canvas.toDataURL("image/png");
    callback(dataURL);
  };

  let imgscr = src + "?t=" + Math.floor(Math.random() * 10000);

  img.src = imgscr;
  if (img.complete || img.complete === undefined) {
    img.src =
      "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw==";
    img.src = imgscr;
  }

  //   callback(img.src);
}

class PDFView extends Component {
  constructor(props) {
    super(props);
  }

  state = {
    contract: {
      ContractPayments: [],
      Customer: {},
      MedicalRecord: { Breed: {}, Pet: {}, Registration_type: {}, Breeder: {} }
    },
    cTerms: [],
    animalTypes: [],
    contractPrintSize: "letter",
    contractTerms: null,
    bannerDone: false,
    headerType: "default",
    shopAddress:"",
    dealerSignature:"",
  };

  componentDidMount() {
    this.props.fetchTerms();
    this.props.fetchAnimalTypes();
    this.props.setClick(this.exportPDF);
    this.props.fetchConfig();
  }

  componentWillReceiveProps = nextProps => {
    if (
      this.props.data.contractsReducer.printContract !==
      nextProps.data.contractsReducer.printContract
    ) {    
      this.setState({
        contract: nextProps.data.contractsReducer.printContract
      });
    }
    if (
      this.props.data.configReducer.configs !==
      nextProps.data.configReducer.configs
    ) {
      let configs = nextProps.data.configReducer.configs;
      if (configs.length < 1) {
        this.props.setDefaultConfig();
      }
      configs.map((item, index) => {
        if (item.name === "contract_terms") {
          let contentState = null;
          let htmlContent = null;
          if (!(item.value === "{}")) {
            contentState = convertFromRaw(JSON.parse(item.value));
            htmlContent = stateToHTML(contentState);
          }
          this.setState({ contractTerms: htmlContent });
        }
        if (item.name === "contract_print_size") {
          this.setState({ contractPrintSize: item.value });
        }
        if (item.name === "contract_header_template") {
          this.setState({ headerType: item.value });
        }
      });
    }

    if (
      this.props.data.contractTermsReducer.cTerms !==
      nextProps.data.contractTermsReducer.cTerms
    ) {
      this.setState({
        cTerms: nextProps.data.contractTermsReducer.cTerms
      });
    }
    if (
      this.props.data.addAnimalTypeReducer.animalTypes !==
      nextProps.data.addAnimalTypeReducer.animalTypes
    ) {
      this.setState({
        animalTypes: nextProps.data.addAnimalTypeReducer.animalTypes
      });
    }
  };
  // componentDidUpdate(prevProps, prevState) {
  //   if (
  //     this.state.bannerDone &&
  //     this.props.data.contractsReducer.printContract
  //   ) {
  //     this.resume.save();
  //   }
  // }

  exportPDF = async () => {
    window.open("", "pdftab");
    var _self = this;
    _self.banner = "";
    _self.path = "";
    let address = "";
      _self.path = `${process.env.REACT_APP_S3_PATH}/${this.props.petShop.currentPetshop.header_path}`;
    toDataURL(_self.path, async function(dataUrl) {
      _self.banner = dataUrl;
      await _self.setState({ bannerDone: dataUrl });
      await _self.resume.save(() => _self.dismiss());
    });
    
    const shopAddress =   this.props.petShop.currentPetshop.address ? this.props.petShop.currentPetshop.address.toUpperCase(): null;
    if(shopAddress === null ){
     address = "";
     _self.setState({ shopAddress : address });
    }else{
     address =  shopAddress.replace( /(<([^>]+)>)/ig, '');
     _self.setState({ shopAddress : address });
    }

    toDataURL( config.signaturePath, async function(dataUrl) {
      _self.dealerSignature = dataUrl;
      await _self.setState({ dealerSignature: dataUrl }); 
    });

  };

  pageTemplate = () => {
    return (
      <HeaderTemplate
        headerType={this.state.headerType}
        petShop={this.props.petShop.currentPetshop}
        banner={this.state.bannerDone}
      />
    );
  };

  dismiss() {
    this.props.unmountMe();
  } 

  render() {
    let today = moment(new Date()).format("YYYY-MM-DD");
    var _self = this;
    const {
      contract,
      contractTerms,
      animalTypes,
      contractPrintSize,
      bannerDone,
      headerType,
      shopAddress,
      dealerSignature
    } = this.state;
    return (
      <div
        style={{
          position: "absolute",
          width: "1000px",
          left: "-1000px"
        }}
      >
        {bannerDone && (
          <PDFExport
            paperSize={contractPrintSize === "legal" ? "Legal" : "Letter"}
            forceProxy={true}
            proxyURL={BASE_URL + "/public/pet_shop/proxyDownload"}
            forcePageBreak=".page-break"
            keepTogether=".sign"
            pageTemplate={this.pageTemplate}
            proxyTarget="pdftab"
            margin="1cm"
            fileName={
              "Medical Record - MC No " +
              contract.MedicalRecord.micro_chip +
              ".pdf"
            }
            title=""
            subject=""
            keywords=""
            ref={r => (this.resume = r)}
          >
            {contract.pet_id ? (
              <React.Fragment>         
                <div
                  style={{
                    padding: "none",
                    backgroundColor: "white",
                    marginTop: "65px",
                    paddingBottom: "25px",
                    overflowX: "hidden",
                    overflowY: "hidden"
                  }}
                >
                  <div className="wrapper" style={{ fontSize: "11px" }}>               
                    <div
                      className="box-one"
                      style={{
                        width: "100%",
                        padding: "7px 7px 7px 7px",                    
                        float: "left",
                        minHeight: "180px",
                        borderRadius: "7px"
                      }}
                    >
                      <div className="content">
                        <h5
                          style={{
                            borderBottom: "1px solid #000",                       
                            width: "50%",
                            float: "left",
                      
                            fontSize: "8px",
                            fontWeight: "bold"
                          }}
                        >
                           AGREEMENT DATE:{" "}
                          <span style={{ fontWeight: "normal" }}>
                             {contract.date ? contract.date.toUpperCase() : ""}
                          </span>
                        </h5>                        
                        <h5
                          style={{
                            borderBottom: "1px dotted #000",
                            paddingLeft: "15px",
                            width: "50%",
                            float: "left",
                      
                            fontSize: "8px",
                            fontWeight: "bold"
                          }}
                        >
                           PUPPY ID:{" "}
                          <span style={{ fontWeight: "normal" }}>
                            {contract.MedicalRecord.pet_id ? contract.MedicalRecord.pet_id.toUpperCase() : ""}
                          </span>
                        </h5>                   
                        <h5
                          style={{
                            borderBottom: "1px dotted #000",                   
                            width: "50%",
                            float: "left",
                 
                            fontSize: "8px",
                            fontWeight: "bold"
                          }}
                        >
                          CUSTOMER'S FULL NAME:{" "}
                          <span style={{ fontWeight: "normal" }}>
                            {contract.Customer.firstname ? contract.Customer.firstname.toUpperCase() : ""} {contract.Customer.lastname ? contract.Customer.lastname.toUpperCase() : ""}
                          </span>
                        </h5>
                        <h5
                          style={{
                            borderBottom: "1px dotted #000",
                            paddingLeft: "15px",
                            width: "50%",
                            float: "left",
                 
                            fontSize: "8px",
                            fontWeight: "bold"
                          }}
                        >
                          BREED:{" "}
                          <span style={{ fontWeight: "normal" }}>
                            {contract.MedicalRecord.Breed.breed_type ? contract.MedicalRecord.Breed.breed_type.toUpperCase() : ""}
                          </span>
                        </h5>               
                        <h5
                          style={{
                            borderBottom: "1px dotted #000",                      
                            width: "50%",
                            float: "left",
                     
                            fontSize: "8px",
                            fontWeight: "bold"
                          }}
                        >
                           ADDRESS:{" "}
                          <span style={{ fontWeight: "normal" }}>
                          {contract.cus_address ? contract.cus_address.toUpperCase() : ""}
                            {contract.cus_address_opt
                              ? ", " + contract.cus_address_opt.toUpperCase()
                              : ""}
                          </span>
                        </h5>
                        <h5
                          style={{
                            borderBottom: "1px dotted #000",
                            paddingLeft: "15px",
                            width: "50%",
                            float: "left",
                     
                            fontSize: "8px",
                            fontWeight: "bold"
                          }}
                        >
                          GENDER:{" "}
                          <span style={{ fontWeight: "normal" }}>
                             {contract.MedicalRecord.sex ? contract.MedicalRecord.sex.toUpperCase() : ""}
                          </span>
                        </h5>              
                        <h5
                          style={{
                            borderBottom: "1px dotted #000",                      
                            width: "50%",
                            float: "left",
                  
                            fontSize: "8px",
                            fontWeight: "bold"
                          }}
                        >
                          CITY, STATE, ZIPCODE:{" "}
                          <span style={{ fontWeight: "normal" }}>
                            {contract.Customer.city
                              ? ", " + contract.Customer.city.toUpperCase()
                              : ""}
                            {contract.Customer.state
                              ? ", " + contract.Customer.state.toUpperCase()
                              : ""}
                            {contract.Customer.zip_code
                             ?","+ contract.Customer.zip_code.toUpperCase() 
                             : ""}
                          </span>
                        </h5>
                        <h5
                          style={{
                            borderBottom: "1px dotted #000",
                            paddingLeft: "15px",
                            width: "50%",
                            float: "left",
                    
                            fontSize: "8px",
                            fontWeight: "bold"
                          }}
                        >
                          DATE OF BIRTH:{" "}
                          <span style={{ fontWeight: "normal" }}>
                            {contract.MedicalRecord.date_of_birth ? contract.MedicalRecord.date_of_birth.toUpperCase() : ""}
                          </span>
                        </h5>                  
                        <h5
                          style={{
                            borderBottom: "1px dotted #000",                        
                            width: "50%",
                            float: "left",
                   
                            fontSize: "8px",
                            fontWeight: "bold"
                          }}
                        >
                           PRIMARY PHONE:{" "}
                          <span style={{ fontWeight: "normal" }}>
                            {contract.Customer.phone_primary ? contract.Customer.phone_primary.toUpperCase() : ""}
                          </span>
                        </h5>
                        <h5
                          style={{
                            borderBottom: "1px dotted #000",
                            paddingLeft: "15px",
                            width: "50%",
                            float: "left",
                   
                            fontSize: "8px",
                            fontWeight: "bold"
                          }}
                        >
                          COLOR:{" "}
                          <span style={{ fontWeight: "normal" }}>
                            {contract.MedicalRecord.color_markings ? contract.MedicalRecord.color_markings.toUpperCase() : ""}
                          </span>
                        </h5>               
                        <h5
                          style={{
                            borderBottom: "1px dotted #000",                    
                            width: "50%",
                            float: "left",
                        
                            fontSize: "8px",
                            fontWeight: "bold"
                          }}
                        >
                          SECONDARY PHONE:{" "}
                          <span style={{ fontWeight: "normal" }}>
                             {contract.Customer.phone_secondary ? contract.Customer.phone_secondary.toUpperCase() : ""}
                          </span>
                        </h5>
                        <h5
                          style={{
                            borderBottom: "1px dotted #000",
                            paddingLeft: "15px",
                            width: "50%",
                            float: "left",
                     
                            fontSize: "8px",
                            fontWeight: "bold"
                          }}
                        >
                          MICROCHIP:{" "}
                          <span style={{ fontWeight: "normal" }}>
                             {contract.MedicalRecord.micro_chip ? contract.MedicalRecord.micro_chip.toUpperCase() : ""}
                          </span>
                        </h5>                                         
                        <h5
                          style={{
                            borderBottom: "1px dotted #000",                    
                            width: "50%",
                            float: "left",
                   
                            fontSize: "8px",
                            fontWeight: "bold"
                          }}
                        >
                          EMAIL:{" "}
                          <span style={{ fontWeight: "normal" }}>
                            {contract.Customer.email ? contract.Customer.email.toUpperCase() : ""}
                          </span>
                        </h5>
                        <h5
                          style={{
                            borderBottom: "1px dotted #000",
                            paddingLeft: "15px",
                            width: "50%",
                            float: "left",
                       
                            fontSize: "8px",
                            fontWeight: "bold"
                          }}
                        >
                          EST. AVAILABLE DATE:{" "}
                          <span style={{ fontWeight: "normal" }}>                      
                            { contract.estimate_available_date ? contract.estimate_available_date :"" }
                          </span>
                        </h5>                
                        <h5
                          style={{
                            borderBottom: "1px dotted #000",                       
                            width: "50%",
                            float: "left",
                        
                            fontSize: "8px",
                            fontWeight: "bold"
                          }}
                        >
                          PRICE:{" "}
                          <span style={{ fontWeight: "normal" }}>
                            $ {contract.price ? parseFloat(contract.price) : 0}
                          </span>
                        </h5>
                        <h5
                          style={{
                            borderBottom: "1px dotted #000",
                            paddingLeft: "15px",
                            width: "50%",
                            float: "left",
                      
                            fontSize: "8px",
                            fontWeight: "bold"
                          }}
                        >
                          HOW DID YOU FIRST FIND US:{" "}
                          <span style={{ fontWeight: "normal" }}>                             
                            {contract.cus_findus ? contract.cus_findus.toUpperCase() : ""}
                          </span>
                        </h5>                  
                        <h5
                          style={{
                            borderBottom: "1px dotted #000",                      
                            width: "50%",
                            float: "left",
                      
                            fontSize: "8px",
                            fontWeight: "bold"
                          }}
                        >
                          TAX:{" "}
                          <span style={{ fontWeight: "normal" }}>
                             ${contract.tax ? parseFloat(contract.tax) : 0}
                          </span>
                        </h5>
                        <h5
                          style={{
                            borderBottom: "1px dotted #000",
                            paddingLeft: "15px",
                            width: "50%",
                            float: "left",
                          
                            fontSize: "8px",
                            fontWeight: "bold"
                          }}
                        >
                          TYPE OF PAYMENT:{" "}
                          <span style={{ fontWeight: "normal" }}>                             
                           {contract.ContractPayments.map(
                              (e, i) =>
                                (i !== 0 ? ` | ` : "") +
                                (e.method === 'other' ? (e.PaymentType.payment_type ? e.PaymentType.payment_type.toUpperCase() : '') : e.method.toUpperCase()) +
                                (e.card_type
                                  ? ` ` +
                                    e.card_type.toUpperCase() +
                                    ` ` +
                                    (e.last_digits ? e.last_digits : "") +
                                    ` $`
                                  : ` $`) +
                                e.amount
                            )}
                          </span>
                        </h5>                                
                        <h5
                         style={{
                            borderBottom: "1px dotted #000",
                            width: "100%",
                            float: "left",                      
                            fontSize: "8px",
                            fontWeight: "bold"
                          }}
                        >
                         TOTAL:{" "}
                          <span style={{ fontWeight: "normal" }}>
                          ${contract.total ? parseFloat(contract.total) : 0}
                          </span>
                        </h5>                                  
                        <h5
                         style={{
                            borderBottom: "1px dotted #000",
                            width: "100%",
                            float: "left",                      
                            fontSize: "8px",
                            fontWeight: "bold"
                          }}
                        >
                         ALTERNATE ADDRESS FOR DELIVERY:{" "}
                          <span style={{ fontWeight: "normal" }}>
                           { contract.del_addess ? contract.del_addess : "N/A" }
                           { contract.del_address_op ?", " + contract.del_address_op : "" }
                           { contract.del_twn ? ", "+ contract.del_twn : "" }
                           { contract.del_state ? ", "+  contract.del_state : "" }
                           { contract.del_zipcode ? ", "+  contract.del_zipcode : "" }
                          </span>
                        </h5>
                      </div>
                    </div>
                  </div>
                  <div
                    style={{
                      width: "100%",
                      display: "block",
                      margin: "auto",
                      paddingBottom: "5px",
                      fontSize: "10px",
                      fontWeight: "bold",
                      textAlign: "center"
                    }}
                  >
                    <u>
                      Terms & Conditions of Purchase
                    </u>                  

                  </div> 

                  <div
                    style={{
                      width: "100%",
                      display: "block",
                      margin: "auto",
                      paddingBottom: "5px",
                      fontSize: "9px",
                      fontWeight: "600"
                    }}
                  >
                     <p className="pdf-small-size">The Terms and Conditions of Purchase Agreement is established between the individual purchasing the puppy (hereinafter referred to as the Purchaser) and Central Park Puppies, based in Westchester County, New York.</p>
                     <p className="pdf-small-size">The Parties are entering into this Agreement for the purpose of purchasing the puppy identified by both Parties (referred to as the "puppy" throughout this Agreement).</p>
                     <p className="pdf-small-size">The puppy shall be sold in its current condition and, unless specified otherwise in this Agreement or the 10-year Health Commitment (which is part of this Agreement), Central Park Puppies does not provide any guarantees, promises, agreements, or warranties regarding the puppy's personality, appearance, size, weight, color, or markings. This includes, but is not limited to, any such guarantees, promises, agreements, or warranties.</p>
                     <p className="pdf-small-size"><b>FOR REASONS WHEREOF</b>, the following terms and conditions shall apply to the purchase of a puppy from Central Park Puppies as follows:</p>
                     <ul style={{margin: "0", padding: "0"}}>
                      <li className="listing-gap">1.<b><u>Purchase Price.</u></b></li>   
                     </ul>                
                     <p className="pdf-small-size">For the purpose of this Agreement and Central Park Puppies 10-Year Health Commitment, the value of the puppy is restricted to the price at which the puppy is being purchased.</p>
                     <p className="pdf-small-size">This does not include any store credit applied, taxes, shipping costs, health certificate fees, veterinarian expenses, shipping crate expenses, or any other costs or expenditures incurred or claimed by the Purchaser in relation to the puppy.</p>                  
                     <ul style={{ margin: "0", padding: "0",}} >
                      <li className="listing-gap">2.<b><u>Behavioral Guidelines.</u></b></li>
                     </ul>               
                     <p className="pdf-small-size">All puppies are being sold as pets, and the Purchaser agrees to not breed the puppy and The Purchaser shall agree to have the puppy neutered or spayed at an appropriate age as advised by their veterinarian.</p>
                     <p className="pdf-small-size">The Purchaser is also committed to providing the puppy with proper care, including but not limited to the following:</p>
                     <p className="pdf-small-size" style={{ margin: "0", marginLeft: "0"}}>a. Choose a dog and breed that is suitable for your home and your lifestyle, avoiding impulsive decisions. Be informed about common health issues for individual breeds, and make sure your housing allows for dog ownership.</p>
                     <p className="pdf-small-size" style={{ margin: "0", marginLeft: "0"}}>b. Committing to the relationship with your dog for its entire life, you shall be responsible for ensuring its well-being.</p>
                     <p className="pdf-small-size" style={{ margin: "0", marginLeft: "0"}}>c. Owning a dog requires both time and money, and it is important to provide a healthy, positive, and safe environment for your pet, including appropriate food, water, shelter, health care, bathing, grooming, and companionship.</p>
                     <p className="pdf-small-size" style={{ margin: "0", marginLeft: "0"}}>d. Assign responsibilities for tasks such as feeding, walking, grooming, etc. among family members.</p>
                     <p className="pdf-small-size" style={{ margin: "0", marginLeft: "0"}}>e. Purchase necessary items such as food, treats, a collar and leash, toys, grooming tools, etc. in advance to make the transition into your home smooth.</p>
                     <p className="pdf-small-size" style={{ margin: "0", marginLeft: "0"}}>f. Move breakables to a higher location, make electrical cords inaccessible, and block off areas of the house that are off-limits for safety purposes. Ensure the yard is securely fenced or has a run. When traveling with your dog, keep him/her safe in the car with a crate or seat belt harness.</p>
                     <p className="pdf-small-size" style={{ margin: "0", marginLeft: "0"}}>g. Create a comfortable place for your dog to rest or have privacy, such as a crate, dog bed, or pile of blankets.</p>
                     <p className="pdf-small-size" style={{ margin: "0", marginLeft: "0"}}>h. Ensure your dog receives proper socialization and training for its well-being and the well-being of others.</p>
                     <p className="pdf-small-size" style={{ margin: "0", marginLeft: "0"}}>i. Provide regular exercise and mental stimulation appropriate for your dog's age, breed, and health status.</p>
                     <p className="pdf-small-size" style={{ margin: "0", marginLeft: "0"}}>j. Establish a relationship with a veterinarian, and provide preventive and therapeutic health care as recommended.</p>
                     <p className="pdf-small-size" style={{ margin: "0", marginLeft: "0"}}>k. Ensure proper identification for your dog, such as tags or microchips, and keep registration information up-to-date.</p>
                     <p className="pdf-small-size" style={{ margin: "0", marginLeft: "0"}}>l. Prevent your dog from having a negative impact on others, including proper waste disposal and noise control, and do not allow it to stray or become feral by integrating it into your community area.</p>
                     <p className="pdf-small-size" style={{ margin: "0", marginLeft: "0" }}>m. Adhere to all laws, regulations, and ordinances, including licensing and leash requirements. </p>
                     <p className="pdf-small-size" style={{ margin: "0", marginLeft: "0" }}>n. Recognize changes in your dog's quality of life and make decisions about end-of-life care with your veterinarian's consultation.</p>
                     <p className="pdf-small-size" style={{ margin: "0", marginLeft: "0" }}>o. Control reproduction through spaying or neutering.</p>
                     <p className="pdf-small-size" style={{ margin: "0", marginLeft: "0" }}>p. Plan for your dog's care in case of an emergency or disaster, including assembling an evacuation kit. Make arrangements for your dog's care in case you are unable to do so.</p>
                     <ul style={{margin: "0", padding: "0"}}>
                      <li className="listing-gap" style={{ marginTop:"10px" }}>3.<b><u>Documentation for Puppy Registration.</u></b></li>
                     </ul>
                     <p className="pdf-small-size">Only registered puppies are eligible to receive registration papers, which may be delivered along with your puppy, or it may take up to six months to receive.</p>
                     <p className="pdf-small-size">All expenses related to acquiring new or renewed registration papers are the sole responsibility of the purchaser. In case of loss of papers, Central Park Puppies will assist the purchaser in obtaining new ones, at the purchaser's expense.</p>
                     <ul style={{margin: "0", padding: "0"}}>
                      <li className="listing-gap" style={{ marginTop:"10px" }}>4.<b><u>Website Information Provided by Breeders.</u></b></li>
                     </ul>                 
                     <p className="pdf-small-size">Central Park Puppies makes every attempt to keep the information provided on its website, <b>centralparkpuppies.com</b>, accurate and current with regards to the puppies sold through its network.</p>
                     <p className="pdf-small-size">This information encompasses the breed, date of birth, color, gender, weight, weight of the parents, and registration details. The Website may contain typographical and photographic inaccuracies, for which Central Park Puppies cannot be held responsible, as the data is provided by its network of breeders.</p>
                     <ul style={{margin: "0", padding: "0"}}>
                      <li className="listing-gap">5.<b><u>Transportation.</u></b></li>
                     </ul>
                     <p className="pdf-small-size" style={{ margin: "0", marginLeft: "0" }}>a. The final determination of the travel date for the puppy is made by the puppy's breeder and the breeder's veterinarian, with the health of the puppy being the primary determining factor. <b>Occasionally, a puppy may need additional time with its breeder before travel.</b></p>
                     <p className="pdf-small-size" style={{ margin: "0", marginLeft: "0" }}>b. Our delivery caretakers work around the clock to ensure your puppy is safely delivered to you as quickly as possible. The lesser the travel time, the better for your puppy’s well-being. Aiming for the shortest travel time, however <b>may cause your puppy’s delivery time to fall between odd hours, during day or night.</b></p>
                     <p className="pdf-small-size" style={{ margin: "0", marginLeft: "0" }}>c. Transportation of the puppy is generally arranged through Central Park Puppies and may include third parties in both arranging and delivery. Occasionally, there may be delays for numerous reasons, including, but not limited to, weather, temperature restrictions, logistics, mechanical failure or other unforeseen events.</p>
                     <p className="pdf-small-size" style={{ margin: "0", marginLeft: "0" }}>d. A person authorized and Twenty One years (21) of age or older must be present with their photo ID to accept the pet on scheduled delivery date. Pet delivery rejections and cancellations are not subject to refunds. Upon delivery of your pet, the transporter will require a photo of the pet with their new owner or authorized person.</p>
                     <p className="pdf-small-size" style={{ margin: "0", marginLeft: "0" }}>e. The purchaser understands and agrees that no refund shall be provided by Central Park Puppies and/or its affiliated breeders due to any airline/airport delays or cancellations of the puppy's flight, whether such travel is domestic or international.</p>
                     <p className="pdf-small-size" style={{ margin: "0", marginLeft: "0" }}>f. The purchaser is solely responsible for any required documentation, health reports, or vaccinations that may be necessary to transport the puppy into any country other than the United States or Canada. Once travel plans are confirmed, there is a non-refundable change fee of $150 USD/CAD if the Purchaser makes any changes to the travel plans.</p>
                     <p className="pdf-small-size" style={{ margin: "0", marginLeft: "0" }}>g. Central Park Puppies shall not be liable, directly or indirectly, for any delays, including, without limitation, those that may cause the purchaser inconvenience or financial loss, nor shall any delay be a valid cause for cancellation of the purchaser's purchase of the puppy.</p>
                     <ul style={{margin: "0", padding: "0"}}> 
                      <li className="listing-gap" style={{ marginTop:"10px" }}>6.<b><u>No Warranties.</u></b></li>
                     </ul>
                     <p className="pdf-small-size">All puppies are sold for the purpose of companionship and not intended for breeding, shows or competitions. Central Park Puppies denies any responsibility regarding the appearance, behavior, character, size, weight, color, compliance with breed standards, or DNA test results of any puppy. Central Park Puppies does not guarantee the precision or comprehensiveness of the Products.</p>
                     <p className="pdf-small-size">Additionally, although every puppy from Central Park Puppies undergoes a thorough examination from head to tail as part of obtaining its Health Certificate, it is still possible for a puppy to travel while having some common conditions.</p>
                     <p className="pdf-small-size">Some of these conditions listed in table below are considered normal for the breed (for more information, please refer to section 10) or are covered under our 10-year Health Commitment in case they persist upon arrival to the purchaser.</p>
                    <table className="table-contract-pdf" style={{ marginTop:"10px", marginLeft: "auto", marginRight: "auto", width: "100%", }}>
                      <tbody>
                        <tr>
                        <td><span>Bite Issues</span></td>
                        <td><span>Coccidia</span></td>
                        <td><span>Spayed</span></td>
                        <td><span>Ticks</span></td>
                        </tr>
                        <tr>
                        <td><span>Body Condition Score between 3-8</span></td>
                        <td><span>Giardia</span></td>
                        <td><span>Neutered</span></td>
                        <td><span>Fleas</span></td>
                        </tr>
                        <tr>
                        <td><span>Ear Debris</span></td>
                        <td><span>Normal for breed underbite</span></td>
                        <td><span>Hernia/Hernia Repair</span></td>
                        <td><span>Hookworms</span></td>
                        </tr>
                        <tr>
                        <td><span>Ear Discharge</span></td>
                        <td><span>Stenotic Nares/Stenotic Nares Repaired</span></td>
                        <td><span>Tail Docked</span></td>
                        <td><span>Tapeworms</span></td>
                        </tr>
                        <tr>
                        <td><span>Ear Mites</span></td>
                        <td><span>Ear Cropping</span></td>
                        <td><span>Dew Claw Removed</span></td>
                        <td><span>Whipworm</span></td>
                        </tr>
                        <tr>
                        <td><span></span></td>
                        <td><span>Undescended Testicles</span></td>
                        <td><span>Open fontanel under 1cm</span></td>
                        <td><span></span></td>
                        </tr>
                      </tbody>
                    </table>
                    <p className="pdf-small-size">Some of these conditions listed in table below are considered normal for the breed (for more information, please refer to section 10) or are covered under our 10-year Health Commitment in case they persist upon arrival to the purchaser.</p>
                    <ul style={{margin: "0", padding: "0"}}>
                     <li className="listing-gap">7.<b><u>Cancellation by the Purchaser.</u></b></li>
                    </ul>
                    <p className="pdf-small-size">The purchaser may cancel their purchase of the puppy by informing Central Park Puppies before receiving confirmation of the delivery date from Central Park Puppies or the breeder. In case of cancellation, the purchaser understands that an administrative fee of up to $495.00 USD/CAD may be charged by Central Park Puppies as damages. If the purchaser cancels after the puppy has started its journey (i.e., leaves the breeder's kennel), they will be responsible for paying the travel and health certificate fees along with an administrative fee of up to $495.00 USD/CAD.</p>
                    <ul style={{margin: "0", padding: "0"}}>
                     <li className="listing-gap">8.<b><u>No Refunds for Monetary Purposes</u></b></li>
                    </ul>
                    <p className="pdf-small-size">Central Park Puppies does not entertain any returns of the puppy that are intended to receive a monetary refund. This holds true regardless of the reason, which may include, but shall not be limited to, allergies, restrictions from landlords or tenants, marital difficulties, difficulties in adjusting to the puppy, or any other reasons.</p>
                    <p className="pdf-small-size">It's essential to understand that puppies need time to acclimate to their new environment. If you're experiencing any issues with your puppy, please get in touch with us at Central Park Puppies so we can assist you in determining if the discomfort is just a normal part of the adjustment period or a more significant concern.</p>
                    <ul style={{margin: "0", padding: "0"}}>
                     <li className="listing-gap">9.<b><u>Returning the Puppy in the Event of Inability to Care</u></b></li>
                    </ul>
                    <p className="pdf-small-size">Should the purchaser be unable to provide adequate care for the puppy at any point in its life, they agree to promptly reach out to Central Park Puppies to discuss options for rehoming the puppy.</p>
                    <p className="pdf-small-size">If a return of the puppy is necessary for any reason, it will be done without a refund or credit, and the purchaser will be responsible for covering all travel expenses. In the event of a surrender, Central Park Puppies will make a reasonable effort to find a new home for the puppy through its rehoming process.</p>
                    <ul style={{margin: "0", padding: "0"}}>
                     <li className="listing-gap">10.<b><u>Getting Familiar with the Breed You're Adopting</u></b></li>
                    </ul>
                    <p className="pdf-small-size">Each breed of dog has its distinct physical and temperamental traits. It is crucial that the Purchaser familiarizes themselves with these traits. The American Kennel Club provides a comprehensive directory of all recognized breeds, which can be found at https://www.akc.org/dog-breeds/. We strongly suggest that the Purchaser visits this site for information about the breed of puppy they are adopting.</p>
                    <p className="pdf-small-size">Central Park Puppies does not guarantee the absence of health issues or surrenders for breeds belonging to the Brachycephalic breed group, where certain conditions that are normal for the breed may be present.</p>
                    <p className="pdf-small-size">Brachycephalic breeds are dogs with flat faces and short, round heads, resulting from shortened skull bones. To prevent heatstroke, these breeds are recommended to be walked in cooler times and using a harness.</p>
                    <p className="pdf-small-size">These breeds are not suited for outdoor living and may require stenotic nares surgery to open nasal passages. Any mixed breed puppy that includes a brachycephalic breed will also be considered as brachycephalic under this agreement as follows:</p>
                    <table className="table-contract-pdf" style={{ marginTop:"10px", marginLeft: "auto", marginRight: "auto", width: "100%" }}>
                      <tbody>
                        <tr>
                        <td><span>Affenpinscher</span></td>
                        <td><span>Cane Corso</span></td>
                        <td><span>Lhasa APSO</span></td>
                        </tr>
                        <tr>
                        <td><span>American Bulldog</span></td>
                        <td><span>Cavalier King Charles Spaniel</span></td>
                        <td><span>Mastiff</span></td>
                        </tr>
                        <tr>
                        <td><span>American Staffordshire</span></td>
                        <td><span>Chihuahua (apple head)</span></td>
                        <td><span>Neapolitan Mastiff</span></td>
                        </tr>
                        <tr>
                        <td><span>Boston Terrier</span></td>
                        <td><span>Shar-Pei (heavily wrinkled)</span></td>
                        <td><span>Newfoundland</span></td>
                        </tr>
                        <tr>
                        <td><span>Boxer</span></td>
                        <td><span>ChowChow</span></td>
                        <td><span>Pug</span></td>
                        </tr>
                        <tr>
                        <td><span>Brussels Griffon</span></td>
                        <td><span>Dogo Argentino</span></td>
                        <td><span>Shi Tzu</span></td>
                        </tr>
                        <tr>
                        <td><span>Bull Mastiff</span></td>
                        <td><span>French Bulldog</span></td>
                        <td><span>Yorkshire Terrier</span></td>
                        </tr>
                        <tr>
                        <td><span>Bulldog</span></td>
                        <td><span>Japanese Chin</span></td>
                        <td><span>Pekingese</span></td>
                        </tr>
                      </tbody>
                    </table>
                    <p className="pdf-small-size">In addition to all these care guidelines, Noted that, puppies which are considered brachycephalic may also be refused Pet Safe Commercial Air travel and face other travel restrictions for traveling on commercial airlines.</p>
                    <p className="pdf-small-size">An underbite refers to a condition where a dog's lower jaw extends further than its upper jaw, creating a gap between the teeth. This is a hereditary condition, but some dog breeds are known for having it as part of their breed standard. This includes purebreds as well as any designer breeds that are created by breeding these breeds.</p>
                    <table className="table-contract-pdf" style={{ marginTop:"10px", marginLeft: "auto", marginRight: "auto", width: "100%"}}>
                      <tbody>
                      <tr>
                      <td><span>Lhasa Apso</span></td>
                      <td><span>Boxer</span></td>
                      </tr>
                      <tr>
                      <td><span>Pekingese</span></td>
                      <td><span>Brussels Griffon</span></td>
                      </tr>
                      <tr>
                      <td><span>Pug</span></td>
                      <td><span>Bulldog</span></td>
                      </tr>
                      <tr>
                      <td><span>Puggle</span></td>
                      <td><span>French Bulldog</span></td>
                      </tr>
                      <tr>
                      <td><span>Boston Terrier</span></td>
                      <td><span>Shih Tzu</span></td>
                      </tr>
                      <tr>
                      <td><span>English Bulldog</span></td>
                      <td><span></span></td>
                      </tr>
                      </tbody>
                    </table>
                    <p className="pdf-small-size">Open fontanelles, or soft spots in the skull, are normal in young puppies, particularly in small breeds. These gaps between the skull's growth plates usually close or harden by 9-12 weeks. However, in some breeds, it is considered acceptable for fontanelles to remain open beyond this age. These open fontanelles typically do not cause any problems for the affected dog, and although there is a theoretical risk of increased susceptibility to brain injury in the event of a head injury, this is rare and dogs with persistent open fontanelles often live normal, healthy lives.</p>
                    <p className="pdf-small-size">Heterochromia refers to a condition in which an individual has two eyes with varying colours, either in part or completely. This variation in eye colour is due to an unequal distribution of melanin in the iris, either an excessive amount (hyperchromic) or a deficient amount (hypochromic).</p>
                    <p className="pdf-small-size">Available genetic research and feedback from breeders and dog owners indicate that certain breeds of dogs have an increased likelihood of producing puppies with heterochromia, or eyes of different colours;</p>
                    <table className="table-contract-pdf" style={{ marginTop:"10px", marginBottom: "10px", marginLeft: "auto", marginRright: "auto", width: "100%" }}>
                      <tbody>
                        <tr>
                        <td><span>Huskies</span></td>
                        <td><span>Welsh Corgis</span></td>
                        </tr>
                        <tr>
                        <td><span>Shetland Sheepdog</span></td>
                        <td><span>Great Danes</span></td>
                        </tr>
                        <tr>
                        <td><span>Alaskan Malamutes</span></td>
                        <td><span>Dachshunds</span></td>
                        </tr>
                        <tr>
                        <td><span>Dalmatians</span></td>
                        <td><span>Australian Shephard dogs</span></td>
                        </tr>
                        <tr>
                        <td><span>Border Collies</span></td>
                        <td><span>Catahoula Leopard dogs</span></td>
                        </tr>
                        <tr>
                        <td><span>Beagles</span></td>
                        <td><span>Chihuahas</span></td>
                        </tr>
                        <tr>
                        <td><span>Shih Tzus</span></td>
                        <td><span></span></td>
                        </tr>
                      </tbody>
                    </table>              
                    <ul style={{margin: "0", padding: "0"}}>
                     <li className="listing-gap">11.<b><u>Privacy Policy Overview</u></b></li>
                    </ul>
                    <p className="pdf-small-size">The Privacy Policy of Central Park Puppies governs the purchaser's experience on the Website and the use of Central Park Puppies services. We strongly encourage the purchaser to thoroughly read through the Privacy Policy to gain an understanding of Central Park Puppies practices regarding the collection, use, sharing, and disclosure of information.</p>
                    <ul style={{margin: "0", padding: "0"}}> 
                     <li className="listing-gap">12.<b><u>Consent for Telephone Calls and Texts</u></b></li>
                    </ul>
                    <p className="pdf-small-size">By signing this Agreement electronically, you are granting permission to Central Park Puppies, affiliated organizations to contact you at the telephone number provided during your purchase. This includes the use of text messages and calls made with an automated telephone dialing system or recorded voice. These calls may include the completion of the AKC/ACA/APRI or other registration processes as part of your purchase. You may also complete registration at any time by contacting those registration companies directly. If you do not wish to receive these text messages or calls, please respond with “STOP” to any message.</p>
                    <ul style={{margin: "0", padding: "0"}}>
                     <li className="listing-gap">13.<b><u>Entire Agreement.</u></b></li>
                    </ul>
                    <p className="pdf-small-size">This Agreement represents the entire agreement between the Parties and no other terms or conditions shall be applicable to this sale.</p>
                    <p className="pdf-small-size" style={{ margin: "10px", marginLeft: "0", marginBottom:"10px", textAlign:"center"}}><b><u>10-YEAR HEALTH COMMITMENT</u></b></p>
                    <p className="pdf-small-size">(For Puppies Purchased After 04-17-2023)</p>
                    <p className="pdf-small-size">Central Park Puppies wants to inform potential puppy owners that owning a puppy involves regular veterinary visits and that the costs of these visits will be the responsibility of the owner.</p>
                    <p className="pdf-small-size">Central Park Puppies makes every effort to ensure that puppies are healthy upon arrival, but as they are living creatures, health issues may arise.</p>
                    <p className="pdf-small-size">Our commitment to addressing any health issues beyond the first year is contingent upon the owner purchasing pet insurance for the puppy for the first full 6 months from the date of arrival.</p>
                    <p className="pdf-small-size">If the owner does not have an active insurance policy by a major medical pet health insurance provider for a minimum of the first 6 months, then our health commitment ends after the first year of your puppy’s arrival date.</p>
                    <p className="pdf-small-size" style={{ margin: "10px", marginLeft: "0", marginBottom:"10px", }}><b><u>DEFINITIONS</u></b></p>
                    <p className="pdf-small-size">The term "Veterinarian" refers to a licensed medical professional for animals as recognized by the state licensing authority.</p>
                    <p className="pdf-small-size">The term “infectious period” refers to in this Agreement, the first Fourteen Days (14) after the puppy has been purchased by the purchaser and transferred to the customer’s home.</p>
                    <p className="pdf-small-size">The "Purchase Price" referred to in this agreement only pertains to the cost of the puppy from Central Park Puppies and does not include any additional expenses such as taxes, shipping fees, health certificate costs, veterinarian expenses, shipping crates or any other costs incurred by the buyer.</p>
                    <p className="pdf-small-size" style={{ margin: "10px", marginLeft: "0", marginBottom:"10px",}}><b><u>OUR COMMITMENT</u></b></p>
                    <p className="pdf-small-size">Before a puppy is sent to its new home, it undergoes a thorough veterinary examination and the breeder follows our vaccination and deworming guidelines.</p>
                    <p className="pdf-small-size">This commitment applies to any health issues that may arise after the puppy arrives.</p>
                    <p className="pdf-small-size">This commitment is only valid for puppies that have been delivered and have continuously resided in the United States and Canada.</p>
                    <ol style={{ margin: "0", padding: "0" }}>
                     <li className="pdf-small-size listing-gap" style={{ marginBottom:"5px" }}><b>Days 1-14:</b> During the first 14 days after arrival, if your puppy is diagnosed with a contagious disease, illness, or parasite, Central Park Puppies will refund you for reasonable and sensible veterinary expenses up to the purchase price of the puppy, as long as you present the bills within Three weeks (03) of the puppy's arrival. This does not require the customer to have pet insurance.</li>
                     <li className="pdf-small-size listing-gap" style={{ marginBottom:"5px" }}><b>Year 1:</b> Within the first year of arrival from Central Park Puppies, if your dog is certified by two licensed veterinarians of your choice to have a congenital or hereditary condition that significantly affects its health and you notify Central Park Puppies in writing of this condition within Five Business Days (05) of the first veterinarian's diagnosis, Central Park Puppies will refund you for reasonable, documented, actual veterinary expenses related to this condition up to the purchase price of the puppy.</li>
                     <li className="pdf-small-size listing-gap" style={{ marginBottom:"5px" }}><b>Years 2-10:</b> For all breeds except for Bulldog breeds, between the first and tenth anniversary of the date of arrival, if your dog is certified by two veterinarians of your choice to have a congenital or hereditary condition that adversely affects the dog’s health and you notify Central Park Puppies in writing within Five Business Days (05) of the first veterinarian's diagnosis, Central Park Puppies will, upon presentation of reasonable, documented, actual veterinary expenses related to this condition, provide you with a credit of 50% of the purchase price of your puppy to be used towards the purchase of another puppy from Central Park Puppies or refund you for your actual veterinary expenses up to 25% of the original purchase price of your puppy, at your discretion.</li>
                    </ol>
                    <p className="pdf-small-size" style={{ margin: "10px", marginLeft: "0", marginBottom:"10px" }}><b><u>EXCLUSIONS FROM 10-YEAR HEALTH COMMITMENT</u></b></p>
                    <p className="pdf-small-size">This commitment does not cover:</p>
                    <ol style={{ margin: "0", padding: "0" }}>
                     <li className="pdf-small-size listing-gap-order-list">The cost of regularly taking a puppy to the Veterinarian, feeding the puppy, providing medicine and supplements, training, grooming, cleaning, and any other expenses involved in caring for and owning a puppy.</li>
                     <li className="pdf-small-size listing-gap-order-list">Injuries or accidents such as foreign object ingestion, falls, bruises, scrapes, bumps, choking, bug bites, or injuries caused by humans, runaway incidents, car-related injuries, and illnesses or injuries stemming from, or connected to, veterinary procedures such as spaying or neutering etc.</li>
                     <li className="pdf-small-size listing-gap-order-list">Contagious diseases or parasites found more than 14 days after the puppy arrives.</li>
                     <li className="pdf-small-size listing-gap-order-list">Diagnosis of hip dysplasia in breeds prone to it and who are either overweight or over-exercised.</li>
                     <li className="pdf-small-size listing-gap-order-list">Physical characteristics, breed standards, or aesthetic preferences such as appearance, size, etc.</li>
                     <li className="pdf-small-size listing-gap-order-list">Behavioral, personality, or temperament traits such as POTTY TRAINING, CHEWING, DIGGING, ETC.</li>
                     <li className="pdf-small-size listing-gap-order-list">Hereditary illnesses diagnosed over 10 years after the puppy arrives.</li>
                     <li className="pdf-small-size listing-gap-order-list">Health issues found over one year after arrival for Bulldog breeds.</li>
                     <li className="pdf-small-size listing-gap-order-list">Bulldogs diagnosed with CHERRY EYE, ENTROPION, LOOSE HIPS, SKIN ALLERGIES, ELONGATED SOFT PALATE, SMALL TRACHEA, STENOTIC NARES, or other typical conditions for the breed at any time.</li>
                    </ol>
                    <p className="pdf-small-size" style={{ margin: "10px", marginLeft:  "0", marginBottom: "10px",}}><b><u>OTHER EXCLUSIONS</u></b></p>
                    <p className="pdf-small-size">Low blood sugar, is a common issue for small breed puppies, especially those weighing 5 lbs. or less. Symptoms include low energy, loss of appetite, sluggishness, abnormal body temperature, and vomiting or diarrhea.</p>
                    <p className="pdf-small-size">To prevent hypoglycemia, it is important to establish a proper and monitored feeding schedule for the puppy, especially during the first two weeks in their new home.</p>
                    <p className="pdf-small-size">It may also be helpful to use supplements like NURI-CAL, NUTRI-STAT, KARO SYRUP, or processed honey to temporarily boost the puppy's energy and encourage them to eat.</p>
                    <p className="pdf-small-size">Kindly note that hypoglycemia is not covered by our 10-year Health Commitment as it is not a hereditary or congenital condition, and it is ultimately the responsibility of the puppy's owner to ensure they are eating properly. We recommend familiarizing yourself with our cited video on hypoglycemia.</p>
                    <p className="pdf-small-size" style={{ margin: "10px", marginLeft: "0", marginBottom:"10px" }}><b><u>PUPPY OWNER OBLIGATIONS</u></b></p>
                    <p className="pdf-small-size">In order to be eligible for our 10-Year Health Commitment, certain obligations must be met. These include:</p>
                    <p className="pdf-small-size" style={{ margin: "0", marginLeft: "0" }}>a. Obtaining proof of pet insurance from a major provider for at least six months from the puppy's arrival;</p>
                    <p className="pdf-small-size" style={{ margin: "0", marginLeft: "0" }}>b. Providing evidence of regular Veterinarian visits and maintaining records;</p>
                    <p className="pdf-small-size" style={{ margin: "0", marginLeft: "0" }}>c. Totally Avoid dog parks and other places where the puppy may interact with unknown dogs until vaccinations are completed;</p>
                    <p className="pdf-small-size" style={{ margin: "0", marginLeft: "0" }}>d. Not breeding the puppy;</p>
                    <p className="pdf-small-size" style={{ margin: "0", marginLeft: "0" }}>e. Providing appropriate exercise;</p>
                    <p className="pdf-small-size" style={{ margin: "0", marginLeft: "0" }}>f. Ensuring regular veterinary care;</p>
                    <p className="pdf-small-size" style={{ margin: "0", marginLeft: "0" }}>g. Following a healthy diet; and</p>
                    <p className="pdf-small-size" style={{ margin: "0", marginLeft: "0" }}>h. Providing proof of valid claims made through pet insurance.</p>
                    <p className="pdf-small-size">Failure to meet these obligations will result in the termination of this Health Commitment.</p>
                    <p className="pdf-small-size" style={{ margin: "10px", marginLeft: "0", marginBottom:"10px" }}><b><u>CONTACT INFORMATION</u></b></p>
                    <p className="pdf-small-size">If you have met the conditions outlined in this 10- year health commitment and your puppy is experiencing a health issue that you believe may be covered under this commitment, it is important that you contact Central Park Puppies immediately. You can do this by emailing help@centralparkpuppies.com or calling (914) 207 7558.</p>
                    <p className="pdf-small-size" style={{ margin: "10px", marginLeft: "0", marginBottom:"10px" }}><b><u>FILING A CLAIM</u></b></p>
                    <p className="pdf-small-size">Central Park Puppies offers two ways to process a claim. The <b>First method</b> is based on the table provided below and shall only require a copy of a paid, itemized invoice from the veterinarian for coverage to be provided. These are services that are not typically covered by pet insurance, but it is recommended that you check with your provider. Please note, the asterisk (*) indicates that the service is only valid if it was performed during the Fourteen Days (14) infectious period, defined as the first Fourteen Days (14)  the puppy has been in the new home as follows:</p>
                    <table className="table-contract-pdf health" style={{ marginTop : "10px" }}>
                      <tbody>
                      <tr>
                      <td><span><b>Issue</b></span></td>
                      <td><span><b>Covered</b></span></td>
                      <td><span><b>Not Covered</b></span></td>
                      <td><span><b>Amount</b></span></td>
                      </tr>
                      <tr>
                      <td><span>Parasites* giardia, coccidia, roundworms, tapeworms, whipworms and hookworms</span></td>
                      <td><span>Lab test confirming presence of ova or cysts</span></td>
                      <td><span>Elisa / Antigen positive only (no ova or cysts present)</span></td>
                      <td><span>Lesser of $200.00 USD or invoiced amounts for tests and medication</span></td>
                      </tr>
                      <tr>
                      <td><span>Vaccinations*</span></td>
                      <td><span>Only applies to core vaccines not received prior to going home.</span></td>
                      <td><span>All vaccines regularly considered a part of the puppy’s development after going home.</span></td>
                      <td><span>$60.00 USD  per booster required.</span></td>
                      </tr>
                      <tr>
                      <td><span>Ear Infections*</span></td>
                      <td><span></span></td>
                      <td><span></span></td>
                      <td><span>Lesser of $200.00 USD or invoiced amount for tests and medication</span></td>
                      </tr>
                      <tr>
                      <td><span>Ear Mites*</span></td>
                      <td><span></span></td>
                      <td><span></span></td>
                      <td><span>Lesser of $150.00 USD or invoiced amount for tests and medication</span></td>
                      </tr>
                      <tr>
                      <td><span>Entropion</span></td>
                      <td><span></span></td>
                      <td><span></span></td>
                      <td><span>Lesser of $1100.00 USD or invoiced amount for procedure performed</span></td>
                      </tr>
                      <tr>
                      <td><span>Eye Infection*</span></td>
                      <td><span></span></td>
                      <td><span></span></td>
                      <td><span>Lesser of $300.00 USD or invoiced amount for tests and medication</span></td>
                      </tr>
                      <tr>
                      <td><span>Fleas and Ticks*</span></td>
                      <td><span></span></td>
                      <td><span></span></td>
                      <td><span>Lesser of $100.00  USD or invoiced amount for medication</span></td>
                      </tr>
                      <tr>
                      <td><span>Repair of Inguinal Hernia</span></td>
                      <td><span>Ideally addressed at time of spay/neutering Only the portion itemized as procedure</span></td>
                      <td><span>Anesthesia, spay/neutering</span></td>
                      <td><span>Lesser of $300.00 USD or invoiced amount for procedure</span></td>
                      </tr>
                      <tr>
                      <td><span>Repair of Umbilical Hernia</span></td>
                      <td><span>Ideally addressing at time of spay/neutering Only the portion itemized as the procedure</span></td>
                      <td><span>Anesthesia, spay/neutering</span></td>
                      <td><span>Lesser of $250.00  USD or invoiced amount for procedure</span></td>
                      </tr>
                      <tr>
                      <td><span>Kennel Cough*</span></td>
                      <td><span></span></td>
                      <td><span></span></td>
                      <td><span>Lesser of $350.00 USD or invoiced amount for medication</span></td>
                      </tr>
                      <tr>
                      <td><span>No Microchip</span></td>
                      <td><span></span></td>
                      <td><span></span></td>
                      <td><span>Lesser of $70.00 USD or invoiced amount to have chip inserted</span></td>
                      </tr>
                      <tr>
                      <td><span>Retained Tooth</span></td>
                      <td><span>Must be addressed at time of spay/neutering</span></td>
                      <td><span>Anesthesia, spay/neutering</span></td>
                      <td><span>Lesser of $500.00 USD or invoiced amount for procedure</span></td>
                      </tr>
                      <tr>
                      <td><span>Upper Respiratory Infection*</span></td>
                      <td><span></span></td>
                      <td><span></span></td>
                      <td><span>Lesser of $300.00 USD or invoiced amount for medication</span></td>
                      </tr>
                      <tr>
                      <td><span>Undescended Testicle</span></td>
                      <td><span>Only the portion allocated to addressing the additional procedure done at time of normal neutering.</span></td>
                      <td><span>Anesthesia, spay/neutering</span></td>
                      <td><span>Lesser of $300.00 USD or invoiced amount for procedure</span></td>
                      </tr>
                      <tr>
                      <td><span>Redundant Vulva</span></td>
                      <td><span>Entire procedure</span></td>
                      <td><span></span></td>
                      <td><span>Lesser of $300.00 USD or invoiced amount for procedure</span></td>
                      </tr>
                      </tbody>
                    </table>
                    <p className="pdf-small-size"><b>The Second method:</b> For issues that are not listed in the table above, such as hereditary or congenital issues that are discovered after the first 14 days of the puppy being in it’s new home referred to as the "infectious period". However, there may be some issues that are discovered during the puppy's initial Veterinarian visit that may require treatment under this method.</p>
                    <p className="pdf-small-size" style={{ margin: "10px", marginLeft: "0", marginBottom:"10px", }}><b><u>INSURANCE POLICY AND OTHER COVERAGE</u></b></p>
                    <p className="pdf-small-size" style={{ margin: "0", marginLeft: "0" }}>a. If you have an active pet insurance policy, you must first seek reimbursement from your provider for any claims related to your puppy.</p>
                    <p className="pdf-small-size" style={{ margin: "0", marginLeft: "0" }}>b. For claims that are deemed valid by your insurance provider, Central Park Puppies will refund you for up to $300 USD of your deductible and 100% of your copay, for a period of 10 years from the purchase of your puppy, with the exception of certain breed exclusions.</p>
                    <p className="pdf-small-size" style={{ margin: "0", marginLeft: "0" }}>c. If your insurance provider does not consider the claim to be valid, there is no further recourse available through Central Park Puppies.</p>
                    <p className="pdf-small-size" style={{ margin: "0", marginLeft: "0" }}>d. In the event that you do not have active pet insurance within the first six months or if you cancel it within the first six months of your puppy's arrival, the 10 Year Health Commitment will not be valid.</p>
                    <p className="pdf-small-size" style={{ margin: "0", marginLeft: "0" }}>e. If you cancel pet insurance after the first 6-month period, a claim will be considered valid once copies of your puppy's health records and any other relevant information about the health issue are provided. Central Park Puppies will then review the claim and determine if and to what extent it is covered under this 10-year health commitment. This process may require additional opinions from veterinarians chosen by Central Park Puppies.</p>
                    <p className="pdf-small-size" style={{ margin: "0", marginLeft: "0" }}>f. If your claim is not deemed valid, there will be no further recourse. It's important to note that in the case of severe knee, elbow, or hip dysplasia, the X-ray should have the registered name and/or number, the name and address of the veterinary clinic or hospital that took the X-ray, and the date it was taken clearly marked in the film emulsion. Additionally, the X-ray and report must meet the submission standards set by the Orthopedic Foundation for Animals.</p>
                    <p className="pdf-small-size" style={{ margin: "10px", marginLeft: "0", marginBottom:"10px", }}><b><u>WHO MAY FILE A CLAIM</u></b></p>
                    <p className="pdf-small-size">This 10-year health commitment is only valid for the original buyer of the puppy from Central Park Puppies and cannot be transferred to any subsequent owners.</p>
                    <p className="pdf-small-size" style={{ margin: "10px", marginLeft: "0", marginBottom:"10px", }}><b><u>STATE LAW</u></b></p>
                    <p className="pdf-small-size">This 10-year health commitment provides specific legal rights to the original purchaser of the puppy from Central Park Puppies, and they may also have additional rights that vary depending on the state they reside in.</p>
                    <p className="pdf-small-size" style={{margin: "10px", marginLeft: "0", marginBottom:"10px", }}><b><u>DISPUTE RESOLUTION</u></b></p>
                    <p className="pdf-small-size">Any disputes related to this 10-year Health Commitment will be resolved through arbitration in accordance with the Terms and Conditions of Sale.</p>
                    <p className="pdf-small-size">If you are eligible for a credit and choose not to use it, Central Park Puppies will not be held responsible for any further claims and you will have forfeited your right to pursue any further legal action against Central Park Puppies.</p>
                    <p className="pdf-small-size" style={{ margin: "10px", marginLeft: "0", marginBottom:"10px", }}><b><u>SEVERABILITY</u></b></p>
                    <p className="pdf-small-size">The purchaser and Central park puppies acknowledge that this Agreement is reasonable, valid and enforceable. However, if any term covenant, condition or provision of this Agreement is held by court of competent jurisdiction to be invalid, void or unenforceable, it is the parties’ intent that such provision be changed in scope by the court only to the extent deemed necessary by that court to render the provision reasonable and enforceable and the remainder of the provisions of this Agreement will in no way be affected, impaired or invalidated as a result.</p>
                    <p className="pdf-small-size" style={{ fontWeight: "bold", margin: "0", marginLeft: "0" }}>Info. Statement For Purchaser of Dog or Cat Pursuant to General Business Law Section 753-B (Form E)</p>
                    <p className="pdf-small-size" style={{ margin: "0", marginLeft: "0" }}>a. Type of Animal: ( ) Cat ( X ) Dog</p>
                    <p className="pdf-small-size" style={{ margin: "0", marginLeft: "0" }}>b. Breeder's name and address, if known. If not known, set forth the name and address of the source of the animal. If the person from whom the dog or cat was obtained is a dealer licensed by the United States Department of Agriculture, set forth the person's name, address and federal identification number:</p>
                    <table className="table table-one-line">
                      <tbody>
                      <tr>
                      <td className="pdf-small-size" style={{ width: "8%" }}><span style={{ fontWeight: "bold", paddingRight: "5px" }}>Source:</span></td>
                      <td className="pdf-small-size" style={{ width: "90%" }}>
                        <span style={{ borderBottom :"1px solid #000" }}>
                          {contract.breeder_breeder
                                ? contract.breeder_breeder
                                : ""}
                              {contract.breeder_addressLine1 
                                ? ", " + contract.breeder_addressLine1 
                                : ""}
                              {contract.breeder_addressLine2 
                                ? ", " + contract.breeder_addressLine2 
                                : ""}
                              {contract.breeder_addressCity
                                ? ", " + contract.breeder_addressCity
                                : ""}
                              {contract.breeder_addressState
                              ?","+ contract.breeder_addressState 
                              : ""}
                              {contract.breeder_addressCountry
                              ?","+ contract.breeder_addressCountry 
                              : ""}
                        </span>               
                      </td>
                      </tr>
                      </tbody>
                    </table>
                    <p className="pdf-small-size" style={{ margin: "0", marginLeft: "0" }}>c. The date of the dog or cat's birth, unless unknown because of the source of the animal, in which case set forth the date the pet dealer received the animal and the location where the animal was received: <span style={{ fontWeight: "bold", paddingRight: "5px", fontSize: "9px" }}>DOB: </span><span style={{ borderBottom: "1px solid #000" }}>{ contract.MedicalRecord.date_of_birth ? contract.MedicalRecord.date_of_birth : "" } </span></p>
                    <p className="pdf-small-size" style={{ margin: "0", marginLeft: "0" }}>d.<u><b>For Dogs ONLY:</b></u></p>
                    <p className="pdf-small-size numbers" style={{ margin: "0", marginLeft: "10px" }}>i. The breed, sex, color and identifying marks at the time of the sale: <span style={{ fontWeight: "bold", paddingRight: "5px", fontSize: "9px" }}>Breed/Sex/Color,etc </span>
                      <span style={{ borderBottom: "1px solid #000"}}>
                      {contract.breed_type
                              ? contract.breed_type
                              : ""}
                            {contract.sex 
                              ? ", " + contract.sex
                              : ""}
                            {contract.color_markings 
                              ? ", " + contract.color_markings 
                              : ""}                   
                      </span>
                    </p>
                    <p className="pdf-small-size numbers" style={{ margin: "0", marginLeft: "10px" }}>ii. If the dog is from a United States Department of Agriculture licensed source, set forth the individual identifying tag,tattoo or collar number for that animal: <span style={{ fontWeight: "bold", paddingRight: "5px", fontSize: "9px" }}>ID tag, tattoo,etc </span><span style={{ borderBbottom: "1px solid #000" }}>{ contract.micro_chip ? contract.micro_chip : "" }</span></p>
                    <p className="pdf-small-size numbers" style={{ margin: "0", marginLeft: "10px" }}>iii. If the breed is unknown or mixed, indicate that fact: <span style={{ fontWeight: "bold", paddingRight: "5px", fontSize: "9px" }}>Breed </span><span style= {{ borderBottom: "1px solid #000" }}>{ contract.breed_type ? contract.breed_type : "" }</span></p>
                    <p className="pdf-small-size numbers" style={{ margin: "0", marginLeft: "10px" }}>iv. If the breed is being sold as being capable of registration, set forth the name and registration number of the sire and dam and the litter number, if known: <span style={{ fontWeight: "bold", paddingRight: "5px", fontSize: "9px" }}>Sire REG # </span><span style={{ borderBottom: "1px solid #000", fontSize: "9px" }}>{ contract.MedicalRecord.sire_number ? contract.MedicalRecord.sire_number : "" }</span><span style={{ fontWeight: "bold", padding: "0 5px", fontSize: "9px" }}> DAM REG # </span><span style={{ borderBottom: "1px solid #000", fontSize: "9px" }}>{ contract.MedicalRecord.dam_number ? contract.MedicalRecord.dam_number : "" }</span></p>
                    <p className="pdf-small-size" style={{ margin: "0", marginLeft: "0" }}>e. The record of immunizations and deworming treatments administered, if any, to the dog or cat as of the time of sale, while the animal was in the possession of the pet dealer, including the dates of administration and the type of vaccine or worming treatments administered: PLEASE REFER TO PET'S MEDICAL RECORD ON ARRIVAL.</p>
                    <p className="pdf-small-size" style={{ margin: "0", marginLeft: "0" }}>f.<u><b>For Cats ONLY:</b></u></p>
                    <p className="pdf-small-size" style={{ margin: "0", marginLeft: "0" }}>Set forth any known diseases, sickness or congenital condition that adversely affects the health of the cat at the time of sale: <span style={{ borderBottom: "1px solid #000" }}>N/A</span></p>
                    <p className="pdf-small-size" style={{ margin: "0", marginLeft: "0" }}>g. Set forth any veterinary treatment or medication received by the dog or cat while in the possession of the pet dealer (other than those set forth in paragraph (e) above): PLEASE REFER TO PET'S MEDICAL RECORD ON ARRIVAL.</p>
                    <p className="pdf-small-size" style={{ margin: "0", marginLeft: "0" }}><b><u>Check One:</u></b></p>
                    <p className="pdf-small-size" style={{ margin: "0", marginLeft: "0" }}>(X) The dog or cat has no known disease or illness, the dog or cat has no known congenital hereditary condition that adversely affects the health of animal at the time of sale; or</p>
                    <p className="pdf-small-size" style={{ margin: "0", marginLeft: "0" }}>() Set forth any known congenital or heredity condition, disease or illness that adversely affects the health of the dog or cat at the time of sale and <u>attach a statement signed by a licensed veterinarian that authorizes the sale of the dog or cat, recommends necessary treatment, if any and verifies that the condition, disease or illness does not require hospitalization or non-elective surgical procedures and it is not likely to require hospitalization or non-elective surgical procedures in the future.</u> A veterinarian statement is not required for intestinal or external parasites unless their presence makes the dog or cat clinically ill or is likely to do so. The statement shall be valid for fourteen (14) business days following examination of the dog or cat by the veterinarian.</p>
                    <p className="pdf-small-size" style={{ margin: "0", marginLeft: "0", textAlign: "center", padding: "10px 0" }}><b>DISCLOSURE OF ANIMAL PEDIGREE REGISTRATION</b></p>
                    <p className="pdf-small-size" style={{ margin: "0", marginLeft: "0" }}>Description of animal: <span style={{ borderBottom: "1px solid #000" }}>{ contract.breed_type }</span></p>
                    <p className="pdf-small-size" style={{ margin: "0", marginLeft: "0" }}>The animal you are purchasing is registered / registrable (circle one) with the: <span style={{ borderBottom: "1px solid #000" }}>{ contract.MedicalRecord && contract.MedicalRecord.Registration_type && contract.MedicalRecord.Registration_type.type ? contract.MedicalRecord.Registration_type.type : "" }</span></p>
                    <p className="pdf-small-size" style={{ margin: "0", marginLeft: "0" }}>Registration means that <span style={{ borderBottom: "1px solid #000" }}>{ contract.MedicalRecord && contract.MedicalRecord.Registration_type && contract.MedicalRecord.Registration_type.type ? contract.MedicalRecord.Registration_type.type : "" }</span></p>
                    <p className="pdf-small-size" style={{ margin: "0", marginLeft: "0",padding: "10px 0" }}><b>Maintains information regarding the parentage and identity of this animal</b></p>
                    <p className="pdf-small-size" style={{ margin: "0", marginLeft: "0" }}>Persons buying animals represented by a pet dealer as being registrable are entitled to the papers necessary to affect such registration within 120 days of purchase. Failure to provide such papers entitles the purchaser to remedies under law. However, if the purchaser notifies the pet dealer within the 120 day period that he or she has not received such papers, the pet dealer shall have an additional 60 days commencing at the end of the 120 day period in which to provide the documents.</p>
                    <p className="pdf-small-size" style={{ margin: "20px", marginLeft: "0", borderTop: "2px solid #000" }}><b>PET DEALER CERTIFICATION</b></p>
                    <table className="table-other" style={{ marginLeft: "auto", marginRight: "auto", width: "100%", marginTop: "5px", marginBottom: "15px" }}>
                      <tbody>
                      <tr>
                      <td style={{ padding: "0px" }}><span style={{ fontWeight: "bold", borderBottom: "1px solid #333" }}> { this.props.petShop.currentPetshop.title ?  this.props.petShop.currentPetshop.title : "" } </span></td>
                      <td style={{ padding: "0px" }}><span style={{ fontWeight: "bold", borderBottom: "1px solid #333" }}> { this.props.petShop.currentPetshop.phone_number ? this.props.petShop.currentPetshop.phone_number : "" } </span></td>
                      <td style={{ padding: "0px" }}><span style={{ fontWeight: "bold", borderBottom: "1px solid #333" }}> { shopAddress ? shopAddress : "" } </span></td>
                      </tr>
                      <tr>
                      <td style={{ padding: "0px" }}>Print name of the pet dealer</td>
                      <td style={{ padding: "0px" }}>Phone Number</td>
                      <td style={{ padding: "0px" }}>Full Address</td>
                      </tr>
                      </tbody>
                    </table>                 
                    <p className="pdf-small-size" style={{ margin: "0", marginLeft: "0" }}><b>HEREBY CERTIFY THE ACCURACY OF THE ABOVE STATEMENTS</b></p>
                    <table className="table-other" style={{ marginLeft: "auto", marginRight: "auto", width: "100%", marginTop: "5px", marginBottom: "5px" }}>
                    <tbody>
                    <tr>
                      <td style={{ width: "40%", padding: "0px"}} className="sign">
                          <p style={{ textAlign: "left", margin: "0", padding: "0", marginLeft: "0" }}><img className="dealer-signature aligncenter" src={dealerSignature} alt=""  width="50px" height="15px"/></p>                    
                      </td>
                      <td style={{ width: "30%",padding: "0px" }}></td>
                      <td style={{ width: "30%", padding: "0px" }}><span style={{ fontWeight: "bold", borderBottom: "1px solid #333", paddingTop : "0px", paddingBottom : "0px"}}>{ contract.date ? contract.date : "" }</span></td>
                    </tr>
                    <tr>
                      <td style={{ width: "40%", padding: "0px" }} className="sign">                    
                          Signature of Pet Dealer
                      </td>
                      <td style={{ width: "30%", padding: "0px" }} className="sign"></td>
                      <td  style={{ width: "40%", padding: "0px" }} className="sign">Date</td>
                    </tr>
                    </tbody>
                    </table>
                    <p className="pdf-small-size" style= {{ margin: "10px", marginLeft: "0", borderTop: "2px solid #000" }}><b>PURCHASER CERTIFICATION</b></p>
                    <table className="table-other" style={{ marginLeft: "auto", marginRight: "auto", width: "100%", marginTop: "10px", marginBottom: "15px" }}>
                    <tbody>
                    <tr>
                    <td style={{ padding: "0px" }}><span style={{ fontWeight: "bold", borderBottom: "1px solid #333" }}> {contract.cus_firstname && contract.cus_lastname ? contract.cus_firstname+ ' '+ contract.cus_lastname : "" } </span></td>
                    <td style={{ padding: "0px" }}><span style={{ fontWeight: "bold", borderBottom: "1px solid #333" }}> {contract.cus_primary ? contract.cus_primary : ""} </span></td>
                    <td style={{ padding: "0px" }}>
                      <span style={{ fontWeight: "bold", borderBottom: "1px solid #333" }}>         
                          {contract.cus_address ? contract.cus_address : ""}            
                          {contract.cus_address_opt ? ", " +contract.cus_address_opt : ""}          
                          {contract.cus_city ? ", " + contract.cus_city: ""}              
                          {contract.cus_state ? ", " + contract.cus_state : ""}                      
                      </span></td>
                    </tr>
                    <tr>
                    <td style={{ padding: "0px" }}> Print name of Purchaser </td>
                    <td style={{ padding: "0px" }}> Phone Number </td>
                    <td style={{ padding: "0px" }}> Full Address </td>
                    </tr>
                    </tbody>
                    </table>
                    <p className="pdf-small-size" style={{ margin: "0", marginLeft: "0", fontWeight: "bold" }}>HEREBY CERTIFY THE ACCURACY OF THE ABOVE STATEMENTS.</p>
                    <p className="pdf-small-size" style={{ margin: "0", marginLeft: "0" }}>I ACKNOWLEDGE RECEIPT OF A COPY OF THE ABOVE ATATEMENTS AND AGREE TO ALL TERMS OF THIS CONTRACT.</p>
                   </div>         
         
                </div>
              </React.Fragment>
            ) : (
              ""
            )}
          </PDFExport>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  petShop: state.petShopReducer,
  user: state.cognito.user,
  data: state
});

const mapDispatchToProps = dispatch => ({
  showContract: id => {
    dispatch(showContract(id));
  },
  fetchTerms: () => {
    dispatch(fetchTerms());
  },
  fetchAnimalTypes: () => {
    dispatch(fetchAnimalTypes());
  },
  fetchConfig: () => {
    dispatch(fetchConfig());
  },
  setDefaultConfig: () => {
    dispatch(setDefaultConfig());
  }
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(PDFView)
);
